import { Container, Button, ButtonGroup, Image } from 'mouse-user-interface';
import styles from './Home.module.scss';
import { CodeBlock } from '../../components';
import Preview from '../Preview/Preview';

function Home() {
    return (
        <div className={styles.home}>
            <Container
                className={styles.hero}
                centre
                column
                style={{ maxWidth: 'none' }}
            >
                <h1 className={styles.title}>
                    Ship faster.<br />
                    Own your UI.
                </h1>
                <p className={styles.subtitle}>
                    A lightweight, highly customizable React component library with built-in theming, dark mode support and modern form handling.
                </p>

                <div style={{ width: '100%', marginTop: '1rem', maxWidth: '400px' }}>
                    <CodeBlock code={`npm i mouse-user-interface`} language="bash" />
                </div>

                <ButtonGroup gap="1rem" className={styles.ctaGroup}>
                    <Button
                        variant="primary"
                        size="lg"
                        onClick={() => window.location.href = '/docs/getting-started'}
                    >
                        Get Started
                    </Button>

                    <Button
                        variant="outline"
                        size="lg"
                        onClick={() => window.location.href = '/preview'}
                    >
                        Live Preview
                    </Button>
                </ButtonGroup>
            </Container>

            <Container padding="lg" className={styles.features}>
                <div className={styles.featureGrid}>
                    <div className={styles.featureCard}>
                        <Image
                            src='/images/fit.svg'
                            alt='lightweight'
                            width={50}
                            height={50}
                            fit='cover'
                            fallbackSrc='/images/noAccess.svg'
                        />
                        <h3>Lightweight</h3>
                        <p>Small bundle size.  Only what you need.</p>
                    </div>

                    <div className={styles.featureCard}>
                        <Image
                            src='/images/earth.svg'
                            alt='earth'
                            width={50}
                            height={50}
                            fit='cover'
                            fallbackSrc='/images/noAccess.svg'
                        />
                        <h3>Full Theming</h3>
                        <p>Built-in dark mode and easy customization using CSS variables.</p>
                    </div>

                    <div className={styles.featureCard}>
                        <Image
                            src='/images/key.svg'
                            alt='key'
                            width={50}
                            height={50}
                            fit='cover'
                            fallbackSrc='/images/noAccess.svg'
                        />
                        <h3>Accessible</h3>
                        <p>Keyboard navigation, ARIA labels, and semantic markup by default.</p>
                    </div>

                    <div className={styles.featureCard}>
                        <Image
                            src='/images/form.svg'
                            alt='form'
                            width={50}
                            height={50}
                            fit='cover'
                            fallbackSrc='/images/noAccess.svg'
                        />
                        <h3>Smart Forms</h3>
                        <p>Powerful form context, validation, and useful hooks included.</p>
                    </div>
                </div>
            </Container>

            <Preview home={true} />
        </div>
    );
}

export default Home;